import { render } from "./imageAndTextTemplate.vue?vue&type=template&id=309abad5"
import script from "./imageAndTextTemplate.vue?vue&type=script&lang=js"
export * from "./imageAndTextTemplate.vue?vue&type=script&lang=js"

import "./imageAndTextTemplate.vue?vue&type=style&index=0&id=309abad5&lang=scss"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__